import { identity } from 'rxjs';
import { Component, OnInit, Input } from '@angular/core';
import { Call } from 'src/app/models/call.model';
import { MgService } from 'src/app/services/mg.service';
import { Pagination } from 'src/app/models/pagination.model';
import { ActivatedRoute, Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';


@Component({
  selector: 'app-mini-square',
  templateUrl: './mini-square.component.html',
  styleUrls: ['./mini-square.component.scss']
})
export class MiniSquareComponent implements OnInit {
  @Input() title: string;
  @Input() value: any;
  @Input() variation: number;
  @Input() link: string;

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  public goToLink() {
    if (!this.link) return
    this.router.navigateByUrl(this.link)
  }
}
